import type { SVGProps } from 'react'
const SvgSyImgOutBox = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<mask id="a" width={18} height={18} x={3} y={3} maskUnits="userSpaceOnUse">
			<path d="M3 11c0-3.771 0-5.657 1.172-6.828S7.229 3 11 3h2c3.771 0 5.657 0 6.828 1.172S21 7.229 21 11v2c0 3.771 0 5.657-1.172 6.828S16.771 21 13 21h-2c-3.771 0-5.657 0-6.828-1.172S3 16.771 3 13z" />
		</mask>
		<g mask="url(#a)">
			<path
				fillOpacity={0.24}
				d="m12.689 14.57-1.497-1.634c-1.27-1.384-1.904-2.077-2.73-2.114-.825-.038-1.52.594-2.91 1.858l-1.921 1.747c-.299.271-.448.407-.533.583l-.024.056c-.074.18-.074.383-.074.786 0 3.669 0 5.503 1.083 6.657q.163.174.346.327c1.212 1.017 3.044.916 6.706.712l3.312-.184c2.61-.145 3.916-.218 4.85-.874.442-.31.815-.704 1.1-1.161.603-.97.603-2.278.603-4.892v-.194c0-.408 0-.612-.038-.805a2 2 0 0 0-.3-.72c-.108-.165-.253-.309-.54-.597-.66-.659-.99-.988-1.357-1.14a2 2 0 0 0-1.53 0c-.368.152-.697.481-1.356 1.14l-.507.507c-.592.592-.889.889-1.248.922a1 1 0 0 1-.228-.005c-.358-.049-.641-.358-1.207-.976"
			/>
		</g>
		<circle cx={6} cy={6} r={2} />
		<path d="M20 4v-.6h.6V4zm-5.576 6.424a.6.6 0 0 1-.848-.848zM19.4 9V4h1.2v5zm.6-4.4h-5V3.4h5zm.424-.176-6 6-.848-.848 6-6z" />
	</svg>
)
export default SvgSyImgOutBox
